import React, { useEffect } from 'react';
import { cn } from './Kit';

export default function Modal({ isOpen, onClose, title, children, className }) {
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className={cn(
        'relative z-10 bg-white rounded-xl border border-lineGray shadow-lg w-full max-w-md mx-4 p-6',
        className
      )}>
        {title && (
          <h2 className="text-lg font-heading font-bold text-gray-900 mb-1">{title}</h2>
        )}
        {children}
      </div>
    </div>
  );
}